import { useEffect, useState } from 'react';

function StatusMessages({
  resetStatuses,
  lookupTableData,
  stopJobStatusPoll,
  WJST_id,
  workato_recipe_id,
  refreshTheRecipe,
}) {
  const [jobCurrentStatus, setJobCurrentStatus] = useState('');
  const [jobCurrentMessage, setJobCurrentMessage] = useState('');

  useEffect(() => {
    if (lookupTableData && lookupTableData?.result?.length > 0 && WJST_id !== 1) {
      job_status_output(lookupTableData);
    }
    console.log('resetStatuses', resetStatuses);
    if (resetStatuses) {
      setJobCurrentStatus(
        <>
          Starting Job <div className="pulse_loader">.</div>
        </>,
      );
      setJobCurrentMessage('');
    }
  }, [lookupTableData, WJST_id, resetStatuses]);

  const job_status_output = (lookupTableData) => {
    // get our reciep job status
    let found_rec_job_status = lookupTableData?.result.filter(
      (job) => job?.data?.recipe_id.toString() === workato_recipe_id.toString(),
    );
    if (found_rec_job_status.length > 0) {
      found_rec_job_status = found_rec_job_status[0];
    }

    const status = found_rec_job_status?.data?.status;
    if (!status) return;

    if (status === 'Error') {
      try {
        let errorString = found_rec_job_status?.data?.message;
        setJobCurrentMessage(errorString);
      } catch (e) {
        console.error('Error parsing JSON string: ', e);
      }
    }

    if (status === 'Error' || status === 'Complete') {
      stopJobStatusPoll();
      setJobCurrentStatus(status);
      refreshTheRecipe(); // runs the parent function
    } else if (status !== '') {
      setJobCurrentStatus(
        <>
          {status} <div className="pulse_loader">.</div>
        </>,
      );
    } else {
      setJobCurrentStatus('');
    }
  };

  return (
    <>
      {workato_recipe_id !== 1 && jobCurrentStatus !== '' ? (
        <>
          <strong>Job Status:</strong> {jobCurrentStatus} <br />
          {jobCurrentMessage ? jobCurrentMessage : null} <br />
        </>
      ) : null}
    </>
  );
}

export default StatusMessages;
